<div class="container-fluid"> 
    <app-loading-element  class="container-fluido componentBelow"></app-loading-element>
</div>
